import type {LightboxApi} from './types';

export const lightbox: LightboxApi = {
  hide: () => {},
  show: () => {},
};
